module.exports = __webpack_public_path__ + "img/background-student-profile.ea83e987.png";